<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && wrapper">
    <div class="banner center" style="max-width:800px;">
        <div class="row row_header">
            <div class="col-3">
                {{localService.languageContent.table.order_nbr}}
            </div>
            <div class="col-3">
                {{localService.languageContent.table.price}}
            </div>
            <div class="col-6 d-flex justify-content-between align-items-center flex-wrap gap-1">
                <span>{{localService.languageContent.table.created_on}}</span>
                <span class="en price" style="border: 1px solid rgba(0, 128, 0, 0.2); background-color: rgba(0, 128, 0, 0.08); padding: 2px 8px; border-radius: 4px;">{{wrapper.content.v1}}</span>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row freeze_col" *ngFor="let item of wrapper.items">
                <div class="col-3">
                    <button class="button_link link_btn" style="margin-top: -3px;" (click)="onRoute(item.key)">
                        <span class="en">{{item.v1}}</span>
                    </button>
                </div>
                <div class="col-3 right">
                    <span class="en">{{item.v2 | number:'1.2-2'}}</span>
                </div>
                <div class="col-6">
                    <span class="en">{{item.v3 | date : 'dd-MMM-yyyy'}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="wrapper && wrapper.paging" [paging]="wrapper.paging" [IsSimple]="true"
        [IsShowSimpleCalenderRange]="true" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()" />
</div>